import React, { FC, PropsWithChildren } from 'react';
import classnames from 'classnames';

import { usePlayerViewRef } from '@/scenarios/legacy-player/lib/contexts/view';
import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

import styles from './style.module.css';

interface Props {
    objectFit?: 'contain' | 'cover';
    onClick?: () => void;
    className?: string;
}

export const PlayerView: FC<PropsWithChildren<Props>> = ({
    objectFit = 'contain',
    className,
    onClick,
    children,
}) => {
    const viewRef = usePlayerViewRef();

    useInstanceEffect(
        (instance) => {
            if (viewRef?.current) {
                instance?.moveToContainer(viewRef.current);
            }
        },
        [viewRef]
    );

    return (
        <div
            className={classnames(styles.root, className, {
                [styles.containVideo]: objectFit === 'contain',
                [styles.coverVideo]: objectFit === 'cover',
            })}
            ref={viewRef}
            tabIndex={-1}
            onClick={onClick}
            role="presentation"
        >
            {children}
        </div>
    );
};
